import { render, staticRenderFns } from "./CardPremium.vue?vue&type=template&id=49f86fd3&scoped=true"
import script from "./CardPremium.vue?vue&type=script&lang=js"
export * from "./CardPremium.vue?vue&type=script&lang=js"
import style0 from "./CardPremium.vue?vue&type=style&index=0&id=49f86fd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f86fd3",
  null
  
)

export default component.exports